export default "__VITE_ASSET__BOVYauLc__"